import { StandardEvents } from '@shopify/events';

class MkShippingProgress extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, options);
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.onCartUpdate, options);
    document.addEventListener('mk:cart-rewards-updated', this.onCartUpdate, options);
    window.addEventListener('pageshow', this.onPageShow, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
    this.version = (this.version || 0) + 1;
  }

  onPageShow = (event) => {
    if (event.persisted) this.onCartUpdate(event);
  };

  onCartUpdate = async (event) => {
    const version = this.version = (this.version || 0) + 1;
    this.request?.abort();
    try {
      await event.promise;
      if (!this.isConnected || version !== this.version) return;
      const request = this.request = new AbortController();
      const response = await fetch(this.dataset.cartUrl, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: request.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === this.version && this.isConnected) this.render(cart);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[mk-shipping-progress]', error);
    }
  };

  render(cart) {
    const total = Number(cart.total_price);
    if (!Number.isFinite(total) || total < 0) return;
    const threshold = Number(this.dataset.threshold);
    const showFrom = Number(this.dataset.showFrom);
    const remaining = Math.max(0, threshold - total);
    const percent = Math.min(100, total / threshold * 100);
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
      style: 'currency',
      currency: cart.currency || 'EUR',
    }).format(remaining / 100);
    const message = remaining === 0
      ? this.dataset.reachedMessage
      : this.dataset.remainingTemplate.replace('[amount]', amount);
    const label = this.querySelector('[data-shipping-message]');
    if (label.textContent !== message) label.textContent = message;
    const track = this.querySelector('[data-shipping-track]');
    track.setAttribute('aria-valuenow', String(Math.round(percent)));
    track.setAttribute('aria-valuetext', message);
    this.querySelector('[data-shipping-fill]').style.setProperty('--shipping-progress', `${percent}%`);
    this.hidden = total < showFrom || !cart.requires_shipping;
  }
}

if (!customElements.get('mk-shipping-progress')) {
  customElements.define('mk-shipping-progress', MkShippingProgress);
}
